import {
  getErrorObjectTransform,
  getOnlyMessageTransform
} from '@shared/helpers/error/vee-validate-transform';

export class ErrorResponse {
  constructor(error) {
    this.config = error.config;
    this.request = error.request;
    this.response = error.response;
  }

  isValidationError() {
    const { status } = this.response;
    return status === 422;
  }

  /**
   * @param fields - необязательное поле.
   * Хранит ключи для локализации названий полей
   * {name: 'Имя пользователя'}
   */
  getValidationErrors(fields = {}) {
    const { data = { errors: [] } } = this.response;
    return getErrorObjectTransform(data.errors, fields);
  }

  getValidationErrorMessages(fields = {}) {
    return getOnlyMessageTransform(this.getValidationErrors(fields));
  }
}
